export const POST_CONTACTUS_REQUEST = "POST_CONTACTUS_REQUEST";
export const POST_CONTACTUS_SUCCESS = "POST_CONTACTUS_SUCCESS";
export const POST_CONTACTUS_FAIL = "POST_CONTACTUS_FAIL";
